// Module
var code = `<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Transaction reference:</td>
      <td>
        <input
          ng-model="\$ctrl.transactionReference"
          type="text"
          autocomplete="off"
          ng-change="\$ctrl.clearTransaction()"
          required>
      </td>
      <td>
        <button
          type="button"
          class="btn btn-success"
          ng-disabled="\$ctrl.form.\$invalid"
          ng-click="\$ctrl.readTransaction()">
          Search
        </button>
      </td>
    </tr>
    </tbody>
  </table>

  <table class="table" ng-if="\$ctrl.transaction">
    <tbody>
    <tr ng-repeat="row in \$ctrl.getDetails(\$ctrl.transaction)">
      <td>{{row[0]}}</td>
      <td>{{row[1]}}</td>
    </tr>
    </tbody>
  </table>
  <div ng-if="\$ctrl.transaction.pesonetStatus && \$ctrl.transaction.status === 'FOR_SETTLEMENT'"
       class="flex-end"
       command-access="UpdatePesonetOutwardTransactionStatus">
    <button
      type="button"
      class=" btn btn-success"
      ng-click="\$ctrl.processPesonetUpdate()">
      Process transaction
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/verify-pesonet-transaction/verify-pesonet-transaction.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;